import { render } from "./ModalPasswordForget.vue?vue&type=template&id=7a42770e"
import script from "./ModalPasswordForget.vue?vue&type=script&lang=js"
export * from "./ModalPasswordForget.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mac/Projects/webshop/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__